import React from "react";
import { Icon } from "@/components/kit";
import { contact } from "@/theme";
import { useI18n } from "@/i18n";

export function ContactActions({ showLogo = false }) {
  const { t } = useI18n();

  return (
    <div
      data-testid="contact-actions"
      className="flex flex-col items-center rounded-2xl border border-line bg-white p-6"
    >
      {showLogo ? (
        <img src="/logo.png" alt="Déco Ligot" className="mb-3 h-14 object-contain" />
      ) : null}
      <h3 className="text-center font-display text-2xl font-semibold text-ink">{t("contact_cta_title")}</h3>
      <p className="mb-5 mt-1 max-w-md text-center text-[13px] leading-relaxed text-mute">{t("contact_cta_sub")}</p>

      <div className="flex w-full max-w-md gap-3">
        <a
          data-testid="contact-call"
          href={`tel:${contact.phone}`}
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-brand-tertiary py-3 text-[15px] font-semibold text-brand-on transition-colors hover:brightness-95"
        >
          <Icon name="phone" size={18} className="text-brand" />
          {t("btn_call")}
        </a>
        <a
          data-testid="contact-appointment"
          href={contact.url}
          target="_blank"
          rel="noreferrer"
          className="flex flex-[1.4] items-center justify-center gap-2 rounded-full bg-brand py-3 text-[15px] font-semibold text-white transition-colors hover:brightness-105"
        >
          <Icon name="calendar" size={18} className="text-white" />
          {t("btn_appointment")}
        </a>
      </div>
      <p className="mt-3 text-[13px] font-medium text-mute">{contact.phoneDisplay}</p>

      <div className="mt-5 w-full max-w-md border-t border-divider pt-5">
        <a
          data-testid="contact-directions"
          href={contact.mapsUrl}
          target="_blank"
          rel="noreferrer"
          className="mb-2 flex items-center gap-2"
        >
          <Icon name="map-pin" size={16} className="text-brand" />
          <span className="flex-1 text-[13px] font-medium text-ink">{contact.address}</span>
          <span className="flex items-center gap-1 rounded-full bg-brand px-3 py-1.5 text-xs font-semibold text-white">
            <Icon name="navigation" size={13} className="text-white" />
            {t("btn_directions")}
          </span>
        </a>
        <p className="mt-1 text-xs font-semibold text-ink-3">{t("showroom_hours")}</p>
        <p className="text-xs text-mute">{t("hours_weekdays")}</p>
        <p className="text-xs text-mute">{t("hours_saturday")}</p>
      </div>
    </div>
  );
}
